import graphql__3be623c51c6f2211d39b from "./__generated__/AnswerPreviewOralInterview_answer.graphql.js";import { graphql, useFragment } from "react-relay";

const EMPTY_ANSWER = "-";

const AnswerPreviewOralInterview = props => {
  const { individualSummary } = useFragment(
    AnswerPreviewOralInterview_answer,
    props.answer
  );

  return individualSummary || EMPTY_ANSWER;
};

const AnswerPreviewOralInterview_answer = graphql__3be623c51c6f2211d39b;

export default AnswerPreviewOralInterview;
